exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-slide{height:450px;color:#fff;display:flex;align-items:center;justify-content:center;box-sizing:border-box;font-size:12px;text-align:center}", ""]);

// exports
